import React from 'react';
import './ContentPage.css';

export const LastUpdated: React.FC = () => (
    <p className="content-last-updated">最后更新时间：2026-09-16</p>
);
